import React, {useCallback, useRef} from 'react';
import {useSelector} from 'react-redux';
import moment from 'moment';
import s from './SettingsBlock.module.css';
import {DateInput} from '../../DateInput/DateInput';
import {InventoryNumber} from './InventoryNumber';
import {Cost} from '../Cost/Cost';
import {AmountAndUnit} from '../AmountAndUnit/AmountAndUnit';
import {Price} from "../Price/Price";

export function SettingsBlock({
                                  amount,
                                  unit,
                                  price,
                                  cost,
                                  inventoryNumber,
                                  purchaseDate,
                                  inventoryGuid,
                                  warehouseId,
                                  setNewInventoryLog
                              }) {
    const date = moment(purchaseDate).format('DD.MM.YYYY');
    const url = helpable.replaceUrlParameters(routable.getRoute('updateInventory'), {
        _guid_: inventoryGuid,
    });
    const inventory = useSelector((state) => state.inventory);
    const {currency} = inventory;
    const hasFullAccess = useSelector((state) => state.restrictions);

    const costBlockRef = useRef(cost);
    const priceBlockRef = useRef(price);

    const updatePrice = useCallback(
        (newValue) => priceBlockRef.current && priceBlockRef.current.update(newValue),
        [priceBlockRef]
    );

    const updateCost = useCallback(
        (newValue) => costBlockRef.current && costBlockRef.current.update(newValue),
        [costBlockRef]
    );

    return (
        <form className={hasFullAccess ? '' : s.readOnlyAccess}>
            <div>
                <div className={s.inputsWrapper}>
                    <div className={s.input}>
                        <InventoryNumber
                            value={inventoryNumber}
                            parameterName="inventory_number"
                            labelText={i18next.t('SettingsBlock.InventoryNumber.labelText')}
                            inventoryGuid={inventoryGuid}
                            hasFullAccess={hasFullAccess}
                        />
                    </div>
                    <div className={s.input}>
                        <div className={s.date}>
                            <label>
                                <span className={s.title}>
                                    {i18next.t('SettingsBlock.dateInput.labelText')}
                                </span>
                            </label>
                            {hasFullAccess && (
                                <DateInput
                                    date={date}
                                    inventoryGuid={inventoryGuid}
                                    requestUrl={url}
                                    parameterName="purchase_date"
                                    options={{
                                        startDate: date,
                                        singleDatePicker: true,
                                        showDropdowns: true,
                                        autoApply: true,
                                    }}
                                    hasFullAccess={hasFullAccess}
                                />
                            )}
                            {!hasFullAccess && <div className={s.valueText}>{date}</div>}
                        </div>
                    </div>
                </div>

                <div className={s.inputsWrapper}>
                    <div className={s.input}>
                        <AmountAndUnit
                            amountValue={amount}
                            unitValue={unit}
                            labelText={i18next.t('SettingsBlock.AmountAndUnit.labelText')}
                            inventoryGuid={inventoryGuid}
                            hasFullAccess={hasFullAccess}
                            warehouseId={warehouseId}
                            setNewInventoryLog={setNewInventoryLog}
                            updateCost={updateCost}
                        />
                    </div>
                    <div className={s.input}>
                        <Price
                            value={price}
                            type="price"
                            labelText={`${i18next.t('SettingsBlock.Price.labelText')} ${currency}`}
                            inventoryGuid={inventoryGuid}
                            hasFullAccess={hasFullAccess}
                            warehouseId={warehouseId}
                            updateCost={updateCost}
                            ref={priceBlockRef}
                        />
                    </div>
                    <div className={s.input}>
                        <Cost
                            value={cost}
                            type="cost"
                            labelText={`${i18next.t('SettingsBlock.Cost.labelText')}, ${currency}`}
                            inventoryGuid={inventoryGuid}
                            hasFullAccess={hasFullAccess}
                            warehouseId={warehouseId}
                            updatePrice={updatePrice}
                            ref={costBlockRef}
                        />
                    </div>
                </div>
            </div>
        </form>
    );
}
